import { Grid } from "@mui/material";
import React, { useCallback, useRef } from "react";
import Header from "../Header/Header1";
import "./Market.scss";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Button,
  FormControlLabel,
} from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import trending_icon from "../../Img/trending_icon.svg";
// import right_arw from "../../Img/right_arw.svg";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import down from "../../Img/down.svg";
import up from "../../Img/up.svg";
import top_gainers from "../../Img/top_gainers.png";
import top_losers from "../../Img/top_losers.png";
import searchs from "../../Img/search.svg";
import btc from "../../Img/btc.svg";
import ltc from "../../Img/ltc.svg";
import kcs from "../../Img/eth.png";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import TradeView from "../../Img/trade-view.png";
import nodata from "../../Img/newnodta.gif";
import usercalls from "../../Axios";
import consts from "../../constant";
import $ from "jquery";
import { toast, ToastContainer } from "react-toastify";
import Loader from "../Loader";
import Footer from "../Footer/footer";
import axios from "axios";
import ImageWithFallback from "../FallbackImage/ImageWithFallback";
import Footernew from "../Footer/Footernew";

// Utility function for debouncing
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

const Market = () => {
  const [value, setValue] = useState(0);
  const [search, setSearch] = useState("");
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const [hideZero, setHideZero] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(10); // Rows per page
  const [load, setLoad] = useState(false);

  const navigate = useNavigate();

  const Subws = useRef(null);
  const subPingws = useRef(null);

  const theme = useTheme();
  const medium = useMediaQuery(theme.breakpoints.up("lg"));

  // table
  const data = [
    {
      currencyName: "BTC",
      currencyNameFull: "Bitcoin",
      price: "$57,552.51",
      change: "+1.12%",
      TradeView: TradeView,
      marketCap: "$1,000,000,000",
      volume: "$1,000M",
      icon: btc,
      rateicon: up,
    },
    {
      currencyName: "LTC",
      currencyNameFull: "Litecoin",
      price: "$58.14",
      TradeView: TradeView,
      change: "+0.37%",
      marketCap: "$1,000,000,000",
      volume: "$1,000M",
      icon: ltc,
      rateicon: up,
    },
    {
      currencyName: "KCS",
      currencyNameFull: "KCS",
      price: "$7.56",
      TradeView: TradeView,
      change: "-0.40%",
      marketCap: "$1,000,000,000",
      volume: "$1,000M",
      icon: kcs,
      rateicon: down,
    },
    {
      currencyName: "BTC",
      currencyNameFull: "Bitcoin",
      price: "$57,552.51",
      change: "+1.12%",
      TradeView: TradeView,
      marketCap: "$1,000,000,000",
      volume: "$1,000M",
      icon: btc,
      rateicon: up,
    },
    {
      currencyName: "LTC",
      currencyNameFull: "Litecoin",
      price: "$58.14",
      TradeView: TradeView,
      change: "+0.37%",
      marketCap: "$1,000,000,000",
      volume: "$1,000M",
      icon: ltc,
      rateicon: up,
    },
    {
      currencyName: "KCS",
      currencyNameFull: "KCS",
      price: "$7.56",
      TradeView: TradeView,
      change: "-0.40%",
      marketCap: "$1,000,000,000",
      volume: "$1,000M",
      icon: kcs,
      rateicon: down,
    },
  ];

  const filteredData = data.filter((row) => {
    const matchesSearch = row?.currencyName
      ?.toLowerCase()
      ?.includes(searchTerm.toLowerCase());
    const hasBalance = hideZero ? row.availableBalance > 0 : true;
    return matchesSearch && hasBalance;
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  // market overview
  const cards1 = [
    {
      img: btc,
      coinname: "BTC",
    },
    {
      img: ltc,
      coinname: "LTC",
    },
    {
      img: kcs,
      coinname: "ETH",
    },
  ];

  const cards2 = [
    {
      img: btc,
      coinname: "TFUEL",
    },
    {
      img: ltc,
      coinname: "AUCTION",
    },
    {
      img: kcs,
      coinname: "FET",
    },
  ];

  const cards3 = [
    {
      img: btc,
      coinname: "ETH",
    },
    {
      img: ltc,
      coinname: "BTC",
    },
    {
      img: kcs,
      coinname: "XRP",
    },
  ];

  const path = usercalls();

  const [totalCount, setTotalCount] = useState(0);

  const [currentPairs, setCurrentPairs] = useState([]);
  const [oldPairs, setOldPairs] = useState([]);

  const getPairs = async (value) => {
    try {
      setLoad(true);
      if (currentPairs) {
        // UnsubscribeStream(currentPairs)
        setOldPairs(currentPairs);
      }

      const url = `${consts.BackendUrl}/getOwnPairs?page=${page + 1
        }&limit=${rowsPerPage}&search=${value ? value : ""}`;
      const response = await path.getCall({ url });
      const result = await response.json();
      if (result?.result?.totalDocs > 0) {
        setTotalCount(result?.result?.totalDocs);
        setCurrentPairs(result?.result?.docs);
        // getAxiosPairs(result?.result?.docs)
        // subScribeStream(result?.result?.docs);
        setLoad(false);
      } else {
        setCurrentPairs([]);
        setTotalCount(0);
        setLoad(false);
      }
      setLoad(false);
    } catch (error) {
      console.log(error, "error");
      setLoad(false);
    }
  };

  useEffect(() => {
    getPairs();
    getAxiosPairs([...cards1, ...cards2, ...cards3]);
  }, [page]);

  const getAxiosPairs = async (currentPairs) => {
    try {
      setLoad(true);
      axios.withCredentials = true;
      if (currentPairs?.length > 0) {
        const symbol = currentPairs?.map((data) => data?.coinname + "-USDT");
        var data;

        const dts = await axios.post(`${consts.BackendUrl}/kucoin/gettickers`, {
          mode: "spot",
          symbol,
        });
        data = dts.data?.result;
        // console.log(data)
        if (data?.length > 0) {
          for (let i = 0; i < data?.length; i++) {
            const element = data[i];
            let priceHtml =
              parseFloat(element?.changeRate * 100).toFixed(2) > 0
                ? `<span class="green" > +${parseFloat(
                  element?.changeRate * 100
                ).toFixed(2)} %</span> `
                : `<span class="red" > ${parseFloat(
                  element?.changeRate * 100
                ).toFixed(2)} %</span> `;

            // $(`.price-${element?.symbol.split('-').join("")}`).html(isNaN(element?.last) ? '0' : Number(element?.last).toFixed(6));
            $(`.pricemarket-${element?.symbol.split("-").join("")}`).html(
              isNaN(element?.last) ? "0" : Number(element?.last).toFixed(6)
            );
            $(`.changemarket-${element?.symbol.split("-").join("")}`).html(
              priceHtml
            );
            // $(`.change-${element?.symbol.split('-').join("")}`).html(priceHtml);
            // $(`.high-${element?.symbol.split('-').join("")}`).html(isNaN(element?.high) ? '0' : Number(element?.high).toFixed(6));
            // $(`.low-${element?.symbol.split('-').join("")}`).html(isNaN(element?.low) ? '0' : Number(element?.low).toFixed(6));
            // $(`.volume-${element?.symbol.split('-').join("")}`).html(isNaN(element?.vol) ? '0' : Number(element?.vol).toFixed(2));
            setLoad(false);
          }
          setLoad(false);
        }
        setLoad(false);
      }
      setLoad(false);
    } catch (error) {
      console.log(error, "error");
      setLoad(false);
    }
  };

  // const getAxiosPairs = async (currentPairs) => {
  //   try {
  //     const symbols = currentPairs?.map(data => data?.pair_symbol?.split("_")?.join(""));
  //     const { data } = await axios.get(`https://api.binance.com/api/v3/ticker/24hr?symbols=${JSON.stringify(symbols)}`)
  //     if (data?.length > 0) {
  //       for (let i = 0; i < data?.length; i++) {
  //         const element = data[i];
  //         let priceHtml = parseFloat(element?.priceChangePercent).toFixed(2) > 0 ?
  //           `<span class="green" > +${parseFloat(element?.priceChangePercent).toFixed(2)} %</span> ` :
  //           `<span class="red" > ${parseFloat(element?.priceChangePercent).toFixed(2)} %</span> `;

  //         $(`.price-${element?.symbol}`).html(isNaN(element?.lastPrice) ? '0' : Number(element?.lastPrice).toFixed(6));
  //         $(`.change-${element?.symbol}`).html(priceHtml);
  //         $(`.high-${element?.symbol}`).html(isNaN(element?.highPrice) ? '0' : Number(element?.highPrice).toFixed(6));
  //         $(`.low-${element?.symbol}`).html(isNaN(element?.lowPrice) ? '0' : Number(element?.lowPrice).toFixed(6));
  //         $(`.volume-${element?.symbol}`).html(isNaN(element?.volume) ? '0' : Number(element?.volume).toFixed(2));
  //       }
  //     }
  //   } catch (error) {
  //     console.log(error, "error")
  //   }
  // }

  // const [Subws, setSubWs] = useState()

  const [kucoinToken, setKucoinToken] = useState("");

  // const UnsubscribeStream = (pairsToUnSubscribe) => {
  //   if (Subws) {
  //     const symbols = pairsToUnSubscribe?.map(data => `${data?.pair_symbol?.split("_")?.join("")?.toLowerCase()}@ticker`);
  //     // Subws.onopen = () => {
  //     if (symbols.length > 0) {
  //       const priceApicall = {
  //         method: "UNSUBSCRIBE",
  //         params: symbols,
  //         id: 1
  //       };
  //       Subws.send(JSON.stringify(priceApicall));
  //     }
  //     // };
  //   }
  // }

  const generateKucoinToken = async () => {
    try {
      setLoad(true);

      axios.withCredentials = true;
      const url = `${consts.BackendUrl}/kucoin/generatekucointoken`;
      const { data } = await axios.get(url);
      if (data.success) {
        let str = data?.result?.replace(/^"(.*)"$/, "$1");
        setKucoinToken(str);
        // console.log(str);
        setLoad(false);
      }
      setLoad(false);
    } catch (err) {
      console.log(err, "error from token");
      setLoad(false);
    }
  };

  // useEffect(() => {
  //   subScribeStream(currentPairs)
  // }, [kucoinToken, currentPairs])

  // const subScribeStream = (pairsToSubscribe) => {

  // const symbols = ``;
  // const priceApicall = {
  //   "id": new Date().getTime(),
  //   "type": "subscribe",
  //   "topic": `/market/snapshot:${symbols}`,
  //   "response": true
  // }

  // ws.onmessage = (event) => {
  //   const json = JSON.parse(event.data);
  //   console.log(json, "json")
  //   try {
  //     let priceHtml = parseFloat(json?.P).toFixed(2) > 0 ?
  //       `<span class="green" > +${parseFloat(json?.P).toFixed(2)} %</span> ` :
  //       `<span class="red" > ${parseFloat(json?.P).toFixed(2)} %</span> `;

  //   } catch (error) {
  //     console.error('Error updating price:', error);
  //   }
  // };

  // };

  const marketSocket = () => {
    try {
      setLoad(true);
      const ws = new WebSocket(
        `wss://ws-api-spot.kucoin.com?token=${kucoinToken}`
      );
      Subws.current = ws;
      ws.onopen = () => {
        // Combine all cards into one array
        const allCards = [...cards1, ...cards2, ...cards3];

        // Create a set to store unique coin names
        const uniqueCoins = new Set();

        // Iterate over all cards and add unique coin names to the set
        allCards.forEach((card) => {
          uniqueCoins.add(card.coinname);
        });

        // Convert the set to an array and map to the desired format
        const uniqueCoinArray = Array.from(uniqueCoins).map(
          (coin) => `${coin}-USDT`
        );
        const curpar = currentPairs?.map((cp) =>
          cp.pair_symbol.split("_").join("-")
        );
        const merge = [...uniqueCoinArray, ...curpar];
        const symbols = merge.join(",");
        // console.log(s)

        const priceApicall = {
          id: new Date().getTime(),
          type: "subscribe",
          topic: `/market/snapshot:${symbols}`,
          response: true,
        };
        // const priceApicall2 = {
        //   "id": new Date().getTime(),
        //   "type": "subscribe",
        //   "topic": `/market/snapshot:${merge}`,
        //   "response": true
        // };
        ws.send(JSON.stringify(priceApicall));
        // ws.send(JSON.stringify(priceApicall2));
      };

      ws.onmessage = (event) => {
        const jsons = JSON.parse(event.data);
        const json = jsons ? jsons?.data?.data : "";
        // console.log(json,"markdata")
        try {
          // setLoad(true);
          let priceHtml =
            parseFloat(json?.changeRate * 100).toFixed(2) > 0
              ? `<span class="green" > +${parseFloat(
                json?.changeRate * 100
              ).toFixed(2)} %</span> `
              : `<span class="red" > ${parseFloat(
                json?.changeRate * 100
              ).toFixed(2)} %</span> `;

          $(`.pricemarket-${json?.symbol.split("-").join("")}`).html(
            isNaN(json?.lastTradedPrice)
              ? "0"
              : Number(json?.lastTradedPrice)
          );
          // $(`.change - ${ json?.s }`).html(isNaN(json?.P) ? '0' : Number(json?.P).toFixed(2) + "%");
          $(`.changemarket-${json?.symbol.split("-").join("")}`).html(
            priceHtml
          );
          $(`.price-${json?.symbol.split("-").join("")}`).html(
            isNaN(json?.lastTradedPrice)
              ? "0"
              : Number(json?.lastTradedPrice)
          );
          $(`.change-${json?.symbol.split("-").join("")}`).html(priceHtml);
          $(`.high-${json?.symbol.split("-").join("")}`).html(
            isNaN(json?.high) ? "0" : Number(json?.high)
          );
          $(`.low-${json?.symbol.split("-").join("")}`).html(
            isNaN(json?.low) ? "0" : Number(json?.low)
          );
          $(`.volume-${json?.symbol.split("-").join("")}`).html(
            isNaN(json?.vol) ? "0" : Number(json?.vol)?.toFixed(2)
          );
          setLoad(false);
        } catch (error) {
          console.error("Error updating price:", error);
          setLoad(false);
        }
      };
      ws.onerror = (error) => {
        console.error("WebSocket Error:", error);
      };

      ws.onclose = (e) => {
        console.log("WebSocket Connection Closed", e.code);
      };

      return () => {
        console.log("Cleaning up WebSocket connection");
        ws.close();
        setLoad(false);
      };
    } catch (error) {
      setLoad(false);
    }
  };

  useEffect(() => {
    generateKucoinToken();
  }, []);

  useEffect(() => {
    if (Subws.current) {
      Subws.current?.close();
      Subws.current = null;
    }
    marketSocket();

    subPingws.current = setInterval(() => {
      if (Subws.current?.readyState === WebSocket.OPEN) {
        const pingMsg = {
          id: `ping-${Date.now()}`,
          type: "ping",
        };
        Subws.current?.send(JSON.stringify(pingMsg));
        // console.log('Sent ping price:', pingMsg.id);
      }
    }, 20000);

    return () => {
      clearInterval(subPingws.current);
    };
  }, [currentPairs, kucoinToken]);

  // Debounced function
  const debouncedSubmit = useCallback(
    debounce((value) => {
      getPairs(value);
    }, 300), // 300ms debounce delay
    []
  );

  // Effect to call debounced function when search changes
  useEffect(() => {
    debouncedSubmit(search);
  }, [search, debouncedSubmit]);

  return (
    <div className="market-full block-top-padding">
      <Header />
      {/* {load && <Loader />} */}
      <ToastContainer />
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="support-head">
            <h1>Markets Overview</h1>
          </div>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <div className="market_overview contain-width">
                <div className="box">
                  <div className="abv_flx">
                    <div className="flx">
                      <img src={trending_icon} alt="img" />
                      <h5>Trending</h5>
                    </div>
                    {/* <NavLink>
                      More <KeyboardArrowRightIcon />
                    </NavLink> */}
                  </div>
                  {load ? (
                    <div className="inline-loader">
                      <Loader />
                    </div>
                  ) : (
                    cards1?.map((row, i) => (
                      <ul key={i}>
                        <li>
                          <div>
                            <span className="num">{i + 1}</span>
                            <span>
                              <img
                                src={`${consts?.imageurl}${row?.coinname}.png`}
                                alt={"T"}
                                className="coin"
                              />
                            </span>
                            <span>{row?.coinname}</span>{" "}
                          </div>
                          <div className={`pricemarket-${row?.coinname}USDT`}>
                            0
                          </div>
                          <div>
                            <span
                              className={`changemarket-${row?.coinname}USDT`}
                            >
                              0
                            </span>
                          </div>
                        </li>
                      </ul>
                    ))
                  )}
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <div className="market_overview contain-width">
                <div className="box">
                  <div className="abv_flx">
                    <div className="flx">
                      <img src={top_gainers} alt="img" />
                      <h5>Top Gainers</h5>
                    </div>
                    {/* <Link >
                      More <KeyboardArrowRightIcon />
                    </Link> */}
                  </div>
                  {load ? (
                    <div className="inline-loader">
                      <Loader />
                    </div>
                  ) : (
                    cards2?.map((row, i) => (
                      <ul key={i}>
                        <li>
                          <div>
                            <span className="num">{i + 1}</span>
                            <span>
                              <img
                                src={`${consts?.imageurl}${row?.coinname}.png`}
                                alt={"T"}
                                className="coin"
                              />
                            </span>
                            <span>{row?.coinname}</span>{" "}
                          </div>
                          <div className={`pricemarket-${row?.coinname}USDT`}>
                            0
                          </div>
                          <div>
                            <span
                              className={`changemarket-${row?.coinname}USDT`}
                            >
                              0
                            </span>
                          </div>
                        </li>
                      </ul>
                    ))
                  )}
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <div className="market_overview contain-width">
                <div className="box">
                  <div className="abv_flx">
                    <div className="flx">
                      <img src={top_losers} alt="img" />
                      <h5>Top Volume Coin</h5>
                    </div>
                    {/* <Link>
                      More <KeyboardArrowRightIcon />
                    </Link> */}
                  </div>
                  {load ? (
                    <div className="inline-loader">
                      <Loader />
                    </div>
                  ) : (
                    cards3?.map((row, i) => (
                      <ul key={i}>
                        <li>
                          <div>
                            <span className="num">{i + 1}</span>
                            <span>
                              <img
                                src={`${consts?.imageurl}${row?.coinname}.png`}
                                alt={"T"}
                                className="coin"
                              />
                            </span>
                            <span>{row?.coinname}</span>{" "}
                          </div>
                          <div className={`pricemarket-${row?.coinname}USDT`}>
                            0
                          </div>
                          <div>
                            <span
                              className={`changemarket-${row?.coinname}USDT`}
                            >
                              0
                            </span>
                          </div>
                        </li>
                      </ul>
                    ))
                  )}
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="market-box">
                <div className="market-watch display-2">
                  <div className="market-watch-title">
                    <h3 className="subtitle">
                      Dreamster-Exchange Market Watch
                    </h3>
                    <h4>Find promising coins and great opportunities!</h4>
                  </div>
                  <div className="input_grp " style={{ marginBottom: "20px" }}>
                    <div className="input_txt left cursor-pointer">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.61606 1.20312C3.89944 1.20312 0.886719 4.21584 0.886719 7.93247C0.886719 11.6491 3.89944 14.6618 7.61606 14.6618C9.21884 14.6618 10.6909 14.1013 11.8469 13.1658L14.449 15.7679C14.5819 15.9007 14.7621 15.9754 14.95 15.9754C15.1379 15.9754 15.3181 15.9007 15.4509 15.7679C15.5838 15.635 15.6584 15.4548 15.6584 15.2669C15.6584 15.079 15.5838 14.8988 15.4509 14.7659L12.8489 12.1639C13.8194 10.9674 14.3479 9.47304 14.3454 7.93247C14.3454 4.21584 11.3327 1.20312 7.61606 1.20312ZM2.30356 7.93247C2.30356 4.99837 4.68197 2.61997 7.61606 2.61997C10.5502 2.61997 12.9286 4.99837 12.9286 7.93247C12.9286 10.8666 10.5502 13.245 7.61606 13.245C4.68197 13.245 2.30356 10.8666 2.30356 7.93247Z"
                          fill="#ccc"
                        />
                      </svg>
                    </div>
                    <input
                      type="text"
                      placeholder="Search"
                      onChange={(e) => {
                        setSearch(e.target.value);
                        setPage(0);
                      }}
                    />
                  </div>
                </div>

                <TableContainer sx={{ marginBottom: "10px" }}>
                  <Table
                    sx={{
                      minWidth: 650,
                      [`& .${tableCellClasses.root}`]: {
                        borderBottom: "none",
                      },
                    }}
                    aria-label="simple table"
                    className="market-table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell align="left">#</TableCell>
                        <TableCell align="left">Name</TableCell>
                        <TableCell align="center">Price</TableCell>
                        <TableCell align="center">
                          <span className="highlight-text">24h </span> changes
                        </TableCell>
                        <TableCell align="center">24h High</TableCell>
                        <TableCell align="center">24h Low</TableCell>
                        <TableCell align="center">24h Volume</TableCell>
                        <TableCell align="center">Action</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {load ? (
                        <TableRow className="tr_row text-center">
                          <TableCell
                            align="center"
                            colSpan={8}
                            style={{
                              verticalAlign: "middle",
                              height: 300,
                            }}
                          >
                            <div className="inline-loader">
                              <Loader />
                            </div>
                          </TableCell>
                        </TableRow>
                      ) : currentPairs?.length > 0 ? (
                        currentPairs?.map((row, index) => (
                          <TableRow className="tr_row" key={index}>
                            <TableCell align="left">
                              {" "}
                              <span>
                                {page == 0
                                  ? index + 1
                                  : page * 10 + (index + 1)}
                              </span>
                              {/* <Checkbox
                                {...label}
                                icon={<StarOutlineRoundedIcon />}
                                checkedIcon={<StarOutlineRoundedIcon />}
                              /> */}
                            </TableCell>
                            <TableCell>
                              <div className="d-flex align-items-center gap-10">
                                <div>
                                  <ImageWithFallback
                                    src={row?.icon}
                                    name={row?.base_asset_name}
                                    alt="coin-img"
                                  />
                                </div>
                                <div>{row?.base_asset_name}</div>
                              </div>
                            </TableCell>
                            <TableCell align="center">
                              <span
                                className={`price-${row?.base_asset_name}USDT`}
                              >
                                {Number(row?.last)?.toFixed(6)}
                              </span>
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={
                                row.change?.includes("-")
                                  ? { color: "#F65454" }
                                  : { color: "#1A8F5C" }
                              }
                            >
                              <span
                                className={`change-${row?.base_asset_name
                                  }USDT ${Number(row?.changeRate * 100) >= 0
                                    ? "green"
                                    : "red"
                                  }`}
                              >
                                {Number(row?.changeRate * 100)?.toFixed(2)} %
                              </span>
                            </TableCell>
                            <TableCell align="center">
                              <span
                                className={`high-${row?.base_asset_name}USDT`}
                              >
                                {row?.high}
                              </span>
                            </TableCell>
                            <TableCell align="center">
                              <span
                                className={`low-${row?.base_asset_name}USDT`}
                              >
                                {row?.low}
                              </span>
                            </TableCell>
                            <TableCell align="center">
                              <span
                                className={`volume-${row?.base_asset_name}USDT`}
                              >
                                {Number(row?.vol)?.toFixed(2)}
                              </span>
                            </TableCell>
                            <TableCell align="center">
                              {/* <Button variant="text" className="highlight-text">
                                Details
                              </Button> */}
                              <Button
                                variant="text"
                                className="highlight-text"
                                onClick={() => {
                                  navigate(
                                    `/trade/${row?.base_asset_name}_USDT`
                                  );
                                }}
                              >
                                Trade
                              </Button>{" "}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow className="tr_row text-center">
                          <TableCell align="center" colSpan={8}>
                            <img src={nodata} alt="nodata" />
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                  <TablePagination
                    rowsPerPageOptions={[]} // Options for rows per page
                    component="div"
                    count={totalCount} // Total number of filtered rows
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </TableContainer>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {medium && <Footernew />}
    </div>
  );
};

export default Market;
